export default {
  buttons: {
    skip: 'Salta',
    back: 'Indietro',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    payment: {
      pending: 'Il tuo pagamento è in elaborazione...',
      success: '👍 Il tuo pagamento è stato elaborato con successo. Grazie!',
      error:
        "⁉️Si è verificato un problema con il pagamento o l'elaborazione richiede più tempo del previsto. Prova ad aggiornare la pagina per 1 minuto, altrimenti contatta il supporto tecnico.",
    },
  },
};
